<template>
	<div>
		<CubePage type="myorder-view" title="数据分析">
			<div slot="content" class="content">
				<div class="topbox" v-if="listObj != null">
					<div class="title">
						<span>￥</span>
						<span class="fontbig">{{listObj.pay_price}}</span>
					</div>
					<div class="topbox-items">
						<div class="topbox-item">
							<p>今日售票数</p>
							<p>{{listObj.order_count}}</p>
						</div>
						<div class="border"></div>
						<div class="topbox-item">
							<p>今日核销量/金额</p>
							<p>{{listObj.receipt_count}} / {{listObj.receipt_price}}</p>
						</div>
						<div class="border"></div>
						<div class="topbox-item">
							<p>退票数/金额</p>
							<p>{{listObj.refund_count}} / {{listObj.refund_price}}</p>
						</div>
					</div>
				</div>
				<div style="margin-top: 10px;">
					<div class="qq-cell">
						<van-cell title="数据概况" to="sd_Gk" is-link icon="points" />
						<van-cell title="数据报表" to="sd_Bb" is-link icon="filter-o" />
						<van-cell title="日报" to="sd_Rb" is-link icon="bar-chart-o" />
						<van-cell title="月报" to="sd_Yb" is-link icon="bar-chart-o" />
						<!-- 	<van-collapse v-model="activeNames">
							<van-collapse-item title="销售简报" name="1">
								<template #icon>
									<div class="left-icon">
										<van-icon name="bar-chart-o" />
									</div>
								</template>
								<van-cell title="日报" to="sd_Rb" is-link />
								<van-cell title="月报" to="sd_Yb" is-link />
							</van-collapse-item>
						</van-collapse>
							<van-collapse v-model="activeNameTs">
							<van-collapse-item title="统计图表" name="1">
								<template #icon>
									<div class="left-icon">
										<van-icon name="chart-trending-o" />
									</div>
								</template>
								<van-cell title="客源" to="sd_Ky" is-link />
								<van-cell title="年龄段" to="age_Tj" is-link />
							</van-collapse-item>
						</van-collapse> -->
					</div>
				</div>
			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				listObj: null,
				activeNames: ['0'],
				activeNameTs: ['0']
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				let that = this;
				var url = "/addons/litestore/api.supplier/index"
				//这里直接调用网络接口
				util.post(url, {},
					function(result) {
						that.listObj = result.data
					},
				);
			}
		}
	}
</script>
<style lang="less">
	@import url("../../../assets/css/order.css");
	@import url("../../../assets/css/listboxless.less");
</style>
<style lang="less" scoped="scoped">
	.qq-cell {
		font-weight: 600;

		.van-collapse-item .left-icon {
			padding-right: 5px;
		}

		.van-collapse-item .left-icon,
		.van-cell__left-icon {
			font-size: 26px;
			// font-weight: 600;
			color: #55aa00;
		}

		.van-collapse-item .right-icon,
		/deep/ .van-cell__right-icon {
			font-size: 20px;
			margin-left: 4px;
			color: #969799;
		}
	}

	.topbox {
		background-color: #fff;
		padding: 10px;
		color: #aaaaaa;
		border-bottom-left-radius: 15px;
		border-bottom-right-radius: 15px;

		.blakcolor {
			color: #000;
		}

		.title {
			line-height: 45px;
			text-align: center;

			.fontbig {
				font-size: 30px;
			}
		}

		.topbox-items {
			height: 60px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;

			p {
				padding: 3px 0;
				font-size: 14px;
			}

			.border {
				width: 0.5;
				height: 70%;
				border: 0.5px solid #FFFFFF;
				background-color: #FFFFFF;
			}
		}
	}

	.conten-box {
		padding-bottom: 200px;
		margin: 15px 0;
		border-radius: 15px;
		background-color: #FFFFFF;

		.title {
			font-size: 14px;
			line-height: 50px;
			padding: 0 15px;
			color: #949494;
			border-bottom: 2px solid #fafafa;
		}
	}
</style>